import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-button', 'loading', 'Пожалуйста, подождите');
